import createYearTabsListingView from '../PeriodTabs/createYearTabsListingView';
import FlexNewsCard from './FlexNewsCard';

export default createYearTabsListingView(FlexNewsCard, {
  displayName: 'NewsYearTabsView',
  containerClass: 'cards__container--news',
  supportsGrid: false,
  hideLinkByDefault: true,
});
